import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as string | null;

const slice = createSlice({
  name: '$bufferLocationId',
  initialState,
  reducers: {
    setBufferLocationId(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (state, action) => {
      return initialState;
    });
  },
});

export const { setBufferLocationId } = slice.actions;
export default slice.reducer;
